import { gridSizeMdLg10, handleErrorForm, ROUTER_PATHS, useCustomStepper } from "@/shared";
import { StepperBoxScene } from "@/shared/components/ui";
import { IDataPreventa, IDataProspecto } from "@/shared/interfaces";
import { useNavigate } from "react-router-dom";
import TabInformacionPersonalPreventa from "../Tabs/TabInformacionPersonalPreventa";
import TabResidenciaPreventa from "../Tabs/TabResidenciaPreventa";
import TabServicioPreventa from "../Tabs/TabServicioPreventa";
import TabDocumentosPreventa from "../Tabs/TabDocumentosPreventa";
import { Tooltip } from "@mui/material";
import { Edit } from "@mui/icons-material";
import "./SavePreventa.css"
import { useFormPreventa } from "@/erp/sale/asesor/preventa/shared/hook/useFormPreventa";
import TabOtrosCargosPreventa from "@/erp/venta_pymes/preventa/shared/componente/tabs_formulario_preventa_pymes/TabOtrosCargosPreventa";
import TipoVentaCanjeEvento from "@/shared/components/ui/TipoVentaCanjeEvento/TipoVentaCanjeEvento";
import LoadPreventa from "../load_preventa/LoadPreventa";


export const TooltipIconEdit = () => {
  return (
    <Tooltip placement="top" title="Editar">
      <Edit color="action" />
    </Tooltip>
  );
};
export const enum emailENUM {
  MANUALMENTE = "INGRESAR MANUALMENTE",
}


interface SavePreventaNew {
  dataProspecto: IDataProspecto;
  dataPreventa?: IDataPreventa;
  editSupervisor?: boolean;
}

const steps = [
  "Informacion",
  "Residencia",
  "Servicio",
  "Otros Cargos",
  "Documentos",
];

export default function SavePreventa({
  dataProspecto,
  dataPreventa,
  editSupervisor = false,
}: SavePreventaNew) {

  const navigate = useNavigate()

  const { activeStep, handleBack,
    handleNext, disableNextStepBtn } = useCustomStepper({ steps: steps })

  const formPreventa = useFormPreventa({
    dataProspecto,
    editSupervisor,
    dataPreventa
  })


  const {
    form,
    handleOnSubmit,
  } = formPreventa

  return (
    <>
      <StepperBoxScene
        py={0}
        titlePage={`${editSupervisor ? "Editar" : "Crear"} Preventa`}
        num_referencia={`${dataProspecto?.razon_social} - L${dataProspecto.linea}`}
        steps={steps}
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        disableNextStepBtn={disableNextStepBtn}
        onCancel={() => {
          navigate(ROUTER_PATHS.ventas.prospectoNav)
          form.reset({})
        }}
        onSave={form.handleSubmit((form) => {
          handleOnSubmit(form)
        }, (error) => {
          handleErrorForm(error)
        })}
        size={gridSizeMdLg10}
        additionalNoteText={
          <TipoVentaCanjeEvento
            prospecto_data={dataProspecto}
          />
        }
      >

        {activeStep === 0 && (
          <TabInformacionPersonalPreventa
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}

        {activeStep === 1 && (
          <TabResidenciaPreventa
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}
        {activeStep === 2 && (
          <TabServicioPreventa
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}
        {activeStep === 3 && (
          <TabOtrosCargosPreventa
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}

        {activeStep === 4 && (
          <TabDocumentosPreventa
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}

      </StepperBoxScene>

      {/* isPendingPreventa={true}
        isPendingUpdatePreventa={formPreventa.isPendingUpdatePreventa} */}

      <LoadPreventa
        open={formPreventa.isPendingUpdatePreventa || formPreventa.isPendingPreventa}
      />

    </>
  )
}